import React from "react";
import { PropTypes } from "prop-types";
import { defaultTemplate } from "common/hoc";
import { CategoryPageMainView, CategorySearchResults } from "application/categories/components";

function CategoryTemplate({ store, t }) {
    const { inSearchMode, categoryGenericSearchViewStore } = store;
    return (
        <React.Fragment>
            {inSearchMode ? (
                <CategorySearchResults categoryGenericSearchViewStore={categoryGenericSearchViewStore} t={t} />
            ) : (
                <CategoryPageMainView store={store} t={t} />
            )}
        </React.Fragment>
    );
}

CategoryTemplate.propTypes = {
    store: PropTypes.object.isRequired,
    t: PropTypes.func.isRequired,
};

export default defaultTemplate(CategoryTemplate);
